export const AgeOptions = [
  "Under 18",
  "18–24",
  "25–34",
  "35–44",
  "45–54",
  "55–64",
  "65 or older",
  "Prefer not to answer",
];

export const SexualityOptions = [
  "Asexual",
  "Bisexual",
  "Gay or Lesbian",
  "Heterosexual / Straight",
  "Pansexual",
  "Prefer not to answer",
];

export const GenderOptions = [
  "Male",
  "Female",
  "Nonbinary / Gender diverse",
  "Prefer not to answer",
];

export const TransgenderOptions = [
  "Yes",
  "No",
  "Prefer not to answer",
];